import { render } from "./ModalFooter.vue?vue&type=template&id=001e3a4e&scoped=true&ts=true"
import script from "./ModalFooter.vue?vue&type=script&lang=ts"
export * from "./ModalFooter.vue?vue&type=script&lang=ts"

import "./ModalFooter.vue?vue&type=style&index=0&id=001e3a4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001e3a4e"]])

export default __exports__